import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { LoaderComponent } from './loader/loader.component';
import { DragScrollDirective } from './directives/drag-scroll.directive';

@NgModule({
  imports: [MatProgressSpinnerModule, CommonModule],
  declarations: [LoaderComponent, DragScrollDirective],
  exports: [LoaderComponent, DragScrollDirective],
})
export class SharedModule {}
